<template>
  <div v-if="item.requester && item.requested" class="directMatchingItem">
    <div class="directMatchingItemButton">
      <MainButton
        :btnText="getBtnLabel(item.status)"
        size="small"
        customFontSize="1.7rem"
        :color="getBtnLightColor(item.status)"
        borderRadius="6px"
        fontWeight="700"
      />
      <h5 class="time">{{ time }}</h5>
    </div>

    <div class="directMatchingItemImages">
      <CorpAdminDirectMatching
        v-if="item.requester.roleName == $role.CORP"
        :item="item.requester"
      />
      <UserAdminDirectMatching
        v-else-if="item.requester.roleName == $role.USER"
        :item="item.requester"
      />

      <div class="matchingButtonInside">
        <figure>
          <img :src="require('@/assets/svg/next.svg')" alt="" />
          <h6 class="matchingImageLabel">&nbsp;</h6>
          <h5 class="matchingImageSubLabel">&nbsp;</h5>
        </figure>
      </div>
      <CorpAdminDirectMatching
        v-if="item.requested.roleName == $role.CORP"
        :item="item.requested"
      />
      <UserAdminDirectMatching
        v-else-if="item.requested.roleName == $role.USER"
        :item="item.requested"
      />
    </div>

    <div class="btnConfirm">
      <MainButton
        btnText="신청서 보기"
        maxWidth="228px"
        width="228px"
        @click="$emit('openModal', item)"
      />
    </div>
  </div>
</template>
<script>
import matchingColorMixins from "@/mixins/matching-color-mixins";
import MainButton from "@/components/button/MainButton.vue";
import UserAdminDirectMatching from "@/components/items/UserAdminDirectMatching.vue";
import CorpAdminDirectMatching from "@/components/items/CorpAdminDirectMatching.vue";
import moment from "moment";

export default {
  name: "ItemAdminDirectMatching",
  mixins: [matchingColorMixins],
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: { MainButton, UserAdminDirectMatching, CorpAdminDirectMatching },
  computed: {
    time() {
      if (!this.item?.submittedTime) return "";
      return moment(this.item?.submittedTime).format("YYYY.MM.DD A hh:mm");
    },
  },
};
</script>

<style scoped lang="scss"></style>
